// extracted by mini-css-extract-plugin
module.exports = {"content":"PromoGuideSheet_content__gSctT","description":"PromoGuideSheet_description__4D7aH","container":"PromoGuideSheet_container___1Ndp","title":"PromoGuideSheet_title__eBz4Z"};